import styled from 'styled-components';

export const ContractTermsTitle = styled.h2`
  font-weight: 600;
  font-size: 1.25rem;
  display: flex;
  justify-content: space-between;
`;
